/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 04/05/2022
 */

import * as React from 'react';
import { Row } from '@/wpt-lib/pdf/common/Table';
import SubHeading from '@/wpt-lib/pdf/common/SubHeading';

const TrainingUndertaken = ({
    trainingUndertaken,
}: Partial<{
    trainingUndertaken: [{ trainingName: string }];
}> & { index: number }) =>
    Array.isArray(trainingUndertaken) && trainingUndertaken.length === 1 ? (
        <Row>
            <SubHeading level={2} text={trainingUndertaken?.[0]?.trainingName} />
        </Row>
    ) : (
        <></>
    );

export default TrainingUndertaken;
